export default __webpack_public_path__ + "static/media/azure-subscription.6d9cfb72.svg";